import { DonorListFilterInput } from 'gql/types';
import { TFunction } from 'i18next';
import { FiltersConfig } from 'modules/common/components/FilterChips/types';

export const createReserveDonorsTableChipsConfig = (
  t: TFunction
): FiltersConfig<DonorListFilterInput> => ({
  bloodType: {
    label: t('bloodType'),
    renderValue: (val) => String(val).replace('_', ''),
  },
});

export const excludedFilterFields: (keyof DonorListFilterInput)[] = [
  'searchingQuery',
  'types',
  'isDaycare',
  'groupId',
  'teamId',
  'name',
  'locations',
  'statuses',
  'lastDonationInterval',
];
